// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { EmptyState } from '../shell/ScreenHelpers';

/**
 * The one "no access" state (AB#35577): what a page shows when the user's role
 * doesn't include what it needs, whether the BFF refused a call (a 403) or the
 * route was reached by a direct link. It names no permission and offers no
 * Retry, because asking again can't change the answer.
 */
export default function NoAccess({
  big = "You don't have access to this page",
  sub = "Your account doesn't include the role this page needs. Contact your administrator if you think you should have access.",
}: {
  big?: string;
  sub?: string;
}) {
  return (
    <div role="status" data-testid="no-access">
      <EmptyState big={big} sub={sub} />
    </div>
  );
}
